<template>
  <div class="footer-panel">
    <div class="site-info">
      <div class="left-info">
        <div class="footer-logo" @click="handlePageRouter('/')"></div>
        <div class="contact-group">
          <div class="contact-pic">
            <a href="https://www.yelp.com">
              <div class="yelp-pic"></div>
            </a>
          </div>
          <div class="contact-pic">
            <a href="https://www.facebook.com/wordpress">
              <div class="facebook-pic"></div>
            </a>
          </div>
          <div class="contact-pic">
            <a href="https://www.instagram.com/explore/tags/wordcamp/">
              <div class="ins-pic"></div>
            </a>
          </div>
          <div class="contact-pic">
            <a href="https://twitter.com/wordpress">
              <div class="twitter-pic"></div>
            </a>
          </div>
          <div class="contact-pic">
            <a href="mailto:wordpress@example.com">
              <div class="email-pic"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="right-info">
        <div class="site-links">
          <div class="first-group">
            <div class="link-name">HOME</div>
            <div class="sub-link" @click="handlePageRouter('/')">
              <span class="sub-link-text">Home</span>
            </div>
          </div>
          <div class="second-group">
            <div class="link-name" @click="handlePageRouter('/coreBusiness')">CORE BUSINESS</div>
            <div class="sub-link">
              <span class="sub-link-text" @click="handleMorePageRouter('/coreBusiness', 0)">Project Procurement&Management</span>
              <span class="sub-link-text" @click="handleMorePageRouter('/coreBusiness', 1)">Supply-chain Management</span>
              <span class="sub-link-text" @click="handleMorePageRouter('/coreBusiness', 2)">Commodity trading</span>
            </div>
          </div>
          <div class="third-group">
            <div class="link-name">SERVICE&PROJECTS</div>
            <div class="sub-link" @click="handlePageRouter('/services')">
              <span class="sub-link-text">Service&Projects</span>
            </div>
          </div>
        </div>
        <div class="site-links-under">
          <div class="first-group">
            <div class="link-name">WHY US</div>
            <div class="sub-link" @click="handlePageRouter('/whyUs')">
              <span class="sub-link-text">Why us</span>
            </div>
          </div>
          <div class="second-group">
            <div class="link-name">CAPABILITIES</div>
            <div class="sub-link" @click="handlePageRouter('/capabilities')">
              <span class="sub-link-text">Capabilities</span>
            </div>
          </div>
          <div class="third-group">
            <div class="link-name">HSE</div>
            <div class="sub-link" @click="handlePageRouter('/hse')">
              <span class="sub-link-text">HSE</span>
            </div>
          </div>
          <div class="fourth-group">
            <div class="link-name">CONTACT US</div>
            <div class="sub-link" @click="handlePageRouter('/contactUs')">
              <span class="sub-link-text">Contact us</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seperate-line"></div>
    <div class="contact-info">
      <div class="email-group">
        <span class="text-title">Email</span>
        <a href="mailto:wordpress@example.com" class="text-content">info@sinopacificsupplychain.com</a>
      </div>
      <div class="address-group">
        <span class="text-title">Address</span>
        <span class="text-content">Room 2312 of Ship Service Mansion, No.18, Yangshupu Road of HongKou District, Shanghai</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
  name: 'footerView',
  props: {

  },
  components: {

  },
  data () {
    return {

    }
  },
  methods: {
    handlePageRouter (pathName) {
      // console.log('======path', pathName)
      this.$router.replace({ path: pathName})
    },
    handleMorePageRouter (pathName, index) {
      // console.log('======path', pathName, index)
      this.$router.replace({ path: pathName, query: { activeIndex: index} })
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">
.footer-panel {
  width: 100%;
  height: 560px;
  background: #0B1D2E;
}


.site-info {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  padding-top: 98px;
}

.footer-logo {
  width: 109px;
  height: 145px;
  background: url('../assets/spsc/footer-logo.png') no-repeat;
  background-size: contain;
  cursor: pointer;
}

.contact-group {
  width: 120px;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 65px;
}

.yelp-pic {
  width: 32px;
  height: 32px;
  background: url('../assets/spsc/yelp.png') no-repeat;
  background-size: contain;
  margin-right: 12px;
  margin-bottom: 16px;
}

.facebook-pic {
  width: 32px;
  height: 32px;
  background: url('../assets/spsc/facebook.png') no-repeat;
  background-size: contain;
  margin-right: 12px;
  margin-bottom: 16px;
}

.ins-pic {
  width: 32px;
  height: 32px;
  background: url('../assets/spsc/ins.png') no-repeat;
  background-size: contain;
  margin-bottom: 16px;
}

.twitter-pic {
  width: 32px;
  height: 32px;
  background: url('../assets/spsc/twitter.png') no-repeat;
  background-size: contain;
  margin-right: 12px;
}

.email-pic {
  width: 32px;
  height: 32px;
  background: url('../assets/spsc/email.png') no-repeat;
  background-size: contain;
}

.right-info {
  margin-left: 164px;
}

.site-links {
  display: flex;
}

.site-links-under {
  display: flex;
  margin-top: 42px;
}

.first-group {
  width: 220px;
}

.second-group {
  width: 325px;
}
.third-group {
  width: 240px;
}
.fourth-group {
  width: 130px;
}

.link-name {
  font-size: 20px;
  color: #FFFFFF;
  line-height: 20px;
  margin-bottom: 33px;
}

.sub-link-text {
  display: inline-block;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  opacity: 0.7;
  margin-bottom: 24px;
  text-decoration: underline;
  cursor: pointer;
}

.seperate-line {
  width: 1200px;
  height: 1px;
  background: #D8D8D8;
  opacity: 0.3;
  margin: 32px auto 40px auto;
}

.contact-info {
  display: flex;
  justify-items: center;
  width: 1200px;
  margin: 0 auto;
}

.text-title {
  display: inline-block;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 20px;
  margin-right: 20px;
}

.text-content {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  opacity: 0.7;

}

.address-group {
  margin-left: 100px;
}
</style>
